module.exports = __webpack_public_path__ + "static/colgadas-002-e65eb2590edfbd6f33411199b26ae705.jpg";